<div class="export-reports-wrapper">
  <div class="export-reports-modal-container">
    <div class="modal-header">
      <div class="header-wrapper">
        <h3 class="title">{{ "view_translations.export_and_reports" | translate }}</h3>
        <ul class="menu">
          <li class="menu-item" [ngClass]="{ 'is-active': exportMenu === 'exportToFile' }" (click)="setExportMenu('exportToFile')">
            <p class="global-transition">{{ "view_translations.export_to_file" | translate }}</p>
          </li>
          <li class="menu-item" [ngClass]="{ 'is-active': exportMenu === 'reports' }" (click)="setExportMenu('reports')">
            <p class="global-transition">{{ "view_translations.reports" | translate }}</p>
          </li>
        </ul>
      </div>
    </div>
    <div class="modal-body">
      <app-export-to-file [selectOptions]="selectOptions" [loading]="loadingFormats" *ngIf="exportMenu === 'exportToFile'"></app-export-to-file>
      <app-reports *ngIf="exportMenu === 'reports'"></app-reports>
    </div>
  </div>
  <button class="btn close-button" (click)="close()">
    <nb-icon icon="cross" pack="icomoon" class="cross-icon"></nb-icon>
  </button>
</div>
